/* eslint-disable react/jsx-key */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  HomeOutlined,
  AccountBookOutlined,
  ContactsOutlined, MinusCircleFilled, UserOutlined, SettingOutlined,
  DisconnectOutlined,
} from '@ant-design/icons';
import {
  Menu, Layout,
} from 'antd';
import H3Image from '@Uilib/h3Image';
import { S3_FILE_URL } from '@Apis/constants';
import TenantActions from '@Actions/tenantActions';
import UserActions from '@Actions/userActions';
import logo from '../../../media/images/logo-without-tagline.png';
// import './style.scss';
import { faCircleMinus, faGear, faHandshake, faHouse, faLinkSlash, faTags, faUser, faUserTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { Sider } = Layout;

/**
 *
 */
class UserMenuAdminHover extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      openKeys: [],
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      getOrg, user,
    } = this.props;
    getOrg(user?.tenant_info?.org_id);
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.userReady) {
      props.getTenantsConfiguration(props.user?.tenant_info?.tenant_id);
      return {
        ...state,
        userReady: true,
        currentPage: props?.history?.location?.pathname,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      user, org,
      tenantsConfiguration,
    } = this.props;
    const {
      currentPage, collapse, openKeys,
    } = this.state;
    return (
      <Fragment>
        <div className="user-menu hide__in-mobile" style={{paddingTop: '5px'}}>
        <Sider
        width="80px"
        // onCollapse={() => this.setState({ collapse: !this.state.collapse })}
        >
        <div className="user-menu__logo-menu__item">
        <Menu
        inlineCollapsed={false}
        theme="light"
        mode="vertical"
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        items={[
          {
            key: 'logo',
            icon: !this.props.user?.tenant_info?.global_config?.settings?.white_label_platform ? (
              <div className="user-menu__logo">
                <H3Image src={logo} className="user-menu__logo-image" />
              </div>
            ) : (
              <div className="user-menu__logo-wl__collapsed">
                <div className="user-menu__logo-image-left-wrapper">
                  <H3Image
                    src={this.props.org?.organisation?.[0]?.logo}
                    className="user-menu__logo-image-left"
                  />
                </div>
              </div>
            ),
            onClick: () => {
              this.props.history.push('/');
              this.setState({ currentPage: '/' });
            },
            label: ''
          }
        ]}
        />
        </div>

        <Menu
        selectedKeys={[currentPage]}
        defaultSelectedKeys={['/admin/business-units']}
        theme="light"
        openKeys={openKeys}
        onClick={(value) => {
          const { history } = this.props;
          history.push(value.key);
          this.setState({ currentPage: value.key });
        }}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        mode="vertical"
        style={{ marginTop: '8px' }}
        items={[
        {
          key: '/admin/business-units',
          icon: <FontAwesomeIcon icon={faHouse} />,
          label: '',
        },
        {
          key: '/admin/users',
          icon: <FontAwesomeIcon icon={faUser} />,
          label: '',
        },
        {
          key: '/admin/inventory',
          icon: <FontAwesomeIcon icon={faTags} />,
          label: ''
        },
        {
          key: '/admin/vendors',
          icon: <FontAwesomeIcon icon={faHandshake} />,
          label: ''
        },
        {
          key: '/admin/customers',
          icon: <FontAwesomeIcon icon={faUserTag} />,
          label: ''
        },
        {
          key: '/admin/configuration',
          icon: <FontAwesomeIcon icon={faGear} />,
          label: ''
        },
        {
          key: '/admin/integration',
          icon: <FontAwesomeIcon icon={faLinkSlash} />,
          label: ''
        },
        {
          key: '/',
          icon: <FontAwesomeIcon icon={faCircleMinus} />,
          label: ''
        }
        ]}
        />
        </Sider>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers, TenantReducers }) => ({
  user: UserReducers.user,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  org: UserReducers.org,
});

const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId)),
  getTenantsConfiguration: (tenantId) => dispatch(TenantActions.getTenantsConfiguration(tenantId)),
  getOrg: (orgId) => dispatch(UserActions.getOrg(orgId)),

});

UserMenuAdminHover.propTypes = {
  user: PropTypes.any,
  org: PropTypes.any,
  history: PropTypes.any,
  tenantsConfiguration: PropTypes.any,
  getTenantsConfiguration: PropTypes.func,
  getOrg: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserMenuAdminHover));
